import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cargando: true,
    todos: [],
    filtrados: [],
    total: 0,
    registrados: 0,
};

export const canceladosSlice = createSlice({
    name: "cancelados",
    initialState,
    reducers: {
        setCargandoCancelados: (state, { payload }) => {
            state.cargando = payload;
        },
        setCanceladosTodos: (state, { payload }) => {
            const boletos = [...payload];
            state.todos = boletos;
            state.filtrados = boletos;
            state.registrados = boletos.length;
            state.total = boletos.reduce(
                (acc, b) => parseInt(acc) + parseInt(b.reembolso),
                0
            );
        },
        filtrarCanceladosUsuario: (state, { payload }) => {
            let numeroUsuario = payload;
            // SI NUMERO USUARIO ESTA VACIO MOSTRAR TODOS LOS BOLETOS
            if (numeroUsuario !== "") {
                state.filtrados = state.todos.filter(
                    (b) => b.agencia === numeroUsuario
                );
                state.registrados = state.filtrados.length;
                state.total = state.filtrados.reduce(
                    (acc, b) => parseInt(acc) + parseInt(b.reembolso),
                    0
                );
                return;
            }
            state.filtrados = [...state.todos];
            state.registrados = [...state.todos].length;
            state.total = [...state.todos].reduce(
                (acc, b) => parseInt(acc) + parseInt(b.reembolso),
                0
            );
        },
        buscarBoleto: (state, { payload: { busqueda, numeroUsuario } }) => {
            let copiaTodos = [...state.todos];
            // SI NO EXISTE EL NUMERO DE USUARIO FILTRAR SOLO POR BUSQUEDA
            if (numeroUsuario === "") {
                const resultadoBusqueda = copiaTodos.filter(
                    (b) =>
                        b.numeroBoleto.match(busqueda) ||
                        b.fechaCancelacion.match(busqueda) ||
                        b.horaCancelacion.match(busqueda)
                );
                state.filtrados = resultadoBusqueda;
                state.registrados = resultadoBusqueda.length;
                state.total = resultadoBusqueda.reduce(
                    (acc, b) => parseInt(acc) + parseInt(b.reembolso),
                    0
                );
                return;
            }
            // SI EXISTE EL NUMERO DE USUARIO FILTRAR POR USUARIO Y BUSQUEDA
            const resultadoBusqueda = copiaTodos.filter(
                (b) =>
                    b.agencia === numeroUsuario &&
                    (b.numeroBoleto.match(busqueda) ||
                        b.fechaCancelacion.match(busqueda) ||
                        b.horaCancelacion.match(busqueda))
            );
            state.filtrados = resultadoBusqueda;
            state.registrados = resultadoBusqueda.length;
            state.total = resultadoBusqueda.reduce(
                (acc, b) => parseInt(acc) + parseInt(b.reembolso),
                0
            );
        },
    },
});

export const {
    setCargandoCancelados,
    setCanceladosTodos,
    filtrarCanceladosUsuario,
    buscarBoleto,
} = canceladosSlice.actions;
export default canceladosSlice.reducer;
